module.exports = __webpack_public_path__ + "static/media/image-3.9502d159.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-64/image-3.jpg
// module id = 264
// module chunks = 0